import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  NotificationHead: {
    TrnTyp: "",
    VocTyp: "",
    VocNo: "",
    PDTuser: "",
    GRNDate: new Date(),
    GRNDocTyp: "",
    GrnDocNo: "",
    Party: "",
    PartyName: "",
    POAmt: "",
    POLineItems: "",
    INVAmt: "",
    INVLineItems: "",
    InvNo: "",
    InvDt: "",
    Type: "",
    VirtualBinCd: "",
    VirtualBinName: "",
    GRNType: "",
    SrNo: "",
    GRNDocTypName: "",
    A_Loc: "",
  },
  NotificationPickingPending: {
    A_VocTyp: "",
    VocName: "",
    A_VocNo: "",
    A_VocDt: "",
    A_Loc: "",
    LocName: "",
    LoadingBayCode: "",
    LoadingBayName: "",
    A_DocStat: "",
    A_Typ: "",
    A_PKL_DocStatus: "",
    ShiftID: "",
  },
  NotificationPickingPendingDetailObjAuto: {
    ItmCd: "",
    ItmName: "",
    CardID: "",
    F_AisleCd: "",
    AisleName: "",
    F_Level: "",
    Level: "",
    F_BinCd: "",
    BinName: "",
    BaseQty: 0,
    PickedQty: 0,
    BalQty: 0,
    SuppRefno1:'',
    DropID:'',
  },
  NotificationList: [
    {
      DocTypCode: "",
      DocTypName: "",
      Date: "",
      Status: "",
    },
  ],
  //pickingpending
  NotificationData: {
    AisleCd: "",
    LevelCd: "",
    Type: "",
  },
};

const SliceNotification = createSlice({
  name: "Notification",
  initialState: { value: initialState },

  reducers: {
    NotificationHead_Set: (state, action) => {
      state.value.NotificationHead = action.payload;
    },
    NotificationPickingPending_Set: (state, action) => {
      state.value.NotificationPickingPending = action.payload;
    },

    NotificationPickingPendingDetailObjAuto_Set: (state, action) => {
      state.value.NotificationPickingPendingDetailObjAuto = action.payload;
    },
    NotificationHead_Status_Set: (state, action) => {
      state.value.NotificationHead.Status = action.payload.Status;
    },
    NotificationPickingPending_Status_Set: (state, action) => {
      state.value.NotificationPickingPending.A_PKL_DocStatus =
        action.payload.A_PKL_DocStatus;
    },
    NotificationList_Set: (state, action) => {
      state.value.NotificationList = action.payload;
    },
    NotificationData_Set: (state, action) => {
      state.value.NotificationData = action.payload;
    },
    NotificationData_OnLoad_Set: (state, action) => {
      state.value.NotificationData = action.payload;
    },
    NotificationPickingPendingAuto_Init: (state, action) => {
      state.value.NotificationPickingPendingDetailObjAuto = {
        ItmCd: "",
        ItmName: "",
        CardID: "",
        F_AisleCd: "",
        AisleName: "",
        F_Level: "",
        Level: "",
        F_BinCd: "",
        BinName: "",
        BaseQty: 0,
        PickedQty: 0,
        BalQty: 0,
        SuppRefno1:'',
        DropID:'',
      };
    },
    Notification_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  NotificationHead_Set,
  Notification_Init,
  NotificationList_Set,
  NotificationData_Set,
  NotificationHead_Status_Set,
  NotificationData_OnLoad_Set,
  NotificationPickingPending_Set,
  NotificationPickingPendingDetailObjAuto_Set,
  NotificationPickingPendingAuto_Init,
  NotificationPickingPending_Status_Set,
} = SliceNotification.actions;
export default SliceNotification.reducer;
